import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'monitor',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/monitor/monitor.module').then(m => m.MonitorPageModule)
    },
    {
        path: 'requests',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/requests/requests.module').then(m => m.RequestsPageModule)
    },
    {
        path: 'reservations',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/reservations/reservations.module').then(m => m.ReservationsPageModule)
    },
    {
        path: 'products-services',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/products-services/products-services.module').then(m => m.ProductsServicesPageModule)
    },
    {
        path: 'chats',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/chats/chats.module').then(m => m.ChatsPageModule)
    },
    {
        path: 'chat/:conversation_key',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/chat/chat.module').then(m => m.ChatPageModule)
    },
    {
        path: 'chats-support',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/chats-support/chats-support.module').then( m => m.ChatsSupportPageModule)
      },
    {
        path: 'reports',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsPageModule)
    },
    {
        path: 'delivery',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/delivery/delivery.module').then(m => m.DeliveryPageModule)
    },
    {
        path: 'shops',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/shops/shops.module').then(m => m.ShopsPageModule)
    },
    {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'business-accounts',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/business-accounts/business-accounts.module').then(m => m.BusinessAccountsPageModule)
    },
    {
        path: 'business-accounts-validate',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/business-accounts-validate/business-accounts-validate.module').then(m => m.BusinessAccountsValidatePageModule)
    },
    {
        path: 'verified-requests',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/verified-requests/verified-requests.module').then(m => m.VerifiedRequestsPageModule)
    },
    {
        path: 'verified',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/verified/verified.module').then(m => m.VerifiedPageModule)
    },
    {
        path: 'push',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/push/push.module').then(m => m.PushPageModule)
    },
    {
        path: 'coupons',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/coupons/coupons.module').then(m => m.CouponsPageModule)
    },
    {
        path: 'explore-section',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/explore-section/explore-section.module').then(m => m.ExploreSectionPageModule)
    },
    {
        path: 'explore-category/:category_key',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/explore-category/explore-category.module').then(m => m.ExploreCategoryPageModule)
    },
    {
        path: 'section/:section',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/section/section.module').then(m => m.SectionPageModule)
    },
    {
        path: 'brick/:brick_key',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/brick/brick.module').then(m => m.BrickPageModule)
    },
    {
        path: 'bricks',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/bricks/bricks.module').then(m => m.BricksPageModule)
    },
    {
        path: 'beers',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/beers/beers.module').then(m => m.BeersPageModule)
    },
    {
        path: 'beerday',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/beerday/beerday.module').then(m => m.BeerdayPageModule)
    },
    {
        path: 'category/:category_key',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/category/category.module').then(m => m.CategoryPageModule)
    },
    {
        path: 'accounts',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/accounts/accounts.module').then(m => m.AccountsPageModule)
    },
    {
        path: 'promotions',
        canActivate: [AuthGuard],
        loadChildren: () => import('./pages/promotions/promotions.module').then(m => m.PromotionsPageModule)
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {

        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
